import { TranslationKeys } from './types/translationStructure';

export const makeFasterPayoutEn = {
  title: 'Make a payout',
  formTitle: 'FPS payouts',
  listTitle: 'Previous payouts',
  single: 'Single',
  mass: 'Mass',
  form: {
    bank: 'Select bank',
    phone: 'Phone number',
    amount: 'Amount, ₽',
    purpose: 'Purpose',
    purposeHelp: 'Any information that will be saved in the bank statement',
    userData: 'Additional data',
    userDataHelp: 'Any information that will be saved with the payout',
    userDataMaxLength: 'Maximum 1000 characters',
    password: 'Payment password',
    send: 'Send',
    successReady: 'Payout accepted and awaiting processing.',
    successSuccess: 'Payout completed successfully.',
    successRejected: 'Payout rejected.',
    invalidBank: 'Select bank',
    invalidPhone: 'Enter phone number',
    invalidAmount: 'Enter amount',
    invalidPassword: 'Enter payment password',
    noAccess: 'Not enough rights',
    sbpNotEnabled: 'SBP payouts are not available for this contract',
  },
} as const;

export const makeFasterPayoutRu: TranslationKeys<typeof makeFasterPayoutEn> = {
  title: 'Сделать выплату',
  formTitle: 'Выплаты СБП',
  listTitle: 'Предыдущие выплаты',
  single: 'Единичная',
  mass: 'Массовая',
  form: {
    bank: 'Выберите банк',
    phone: 'Номер телефона',
    amount: 'Сумма, ₽',
    purpose: 'Назначение',
    purposeHelp: 'Любая информация, которая сохранится в выписке банка',
    userData: 'Дополнительные данные',
    userDataHelp: 'Любая информация, которая сохранится вместе с выплатой',
    userDataMaxLength: 'Максимум 1000 символов',
    password: 'Платежный пароль',
    send: 'Отправить',
    successReady: 'Выплата принята и ожидает обработки',
    successSuccess: 'Выплата проведена успешно',
    successRejected: 'Выплата отклонена',
    invalidBank: 'Выберите банк',
    invalidPhone: 'Введите номер телефона',
    invalidAmount: 'Введите сумму',
    invalidPassword: 'Введите платежный пароль',
    noAccess: 'Недостаточно прав',
    sbpNotEnabled: 'СБП-выплаты недоступны для этого контракта',
  },
} as const;
